export default {
  title: 'JOB POST GENERATOR',
  instructions: [
    {
      step: 'Step 1',
      body: `Fill in the relevant fields to populate the important details about the job. (Look at the example for the desired layout)`
    },
    {
      step: 'Step 2',
      body: `Check your information is correct and matches the format desired, then click the 'Copy Job Post' button below the preview.`
    },
    {
      step: 'Step 3',
      body: `Paste to textio and check ad before exporting and copying to Workday`
    }
  ],
  fields: {
    description: {
      title: 'Use a clear short job title with only known acronyms and under 50 characters.',
      placeholder: 'Enter the job description',
      options: false
    },
    location: {
      title: 'This has to be a location where the role you are advertising is based',
      placeholder: 'Enter the role location',
      options: false
    },
    questions: {
      title:
        'Start with 2 questions e.g. Are you a continuous improvement (CI) expert with a passion for supporting people and standardising processes? Want to work on exciting projects at the heart of a global business? Then keep reading…',
      placeholder: 'Enter two questions',
      options: false
    },
    role: {
      title: 'Add one line about the local brand and candidate’s role; what is the challenge they solve? What is in it for them? (25-40 words)',
      placeholder: 'Enter one line about the candidate’s role',
      options: false
    },
    intro: {
      title: 'Write a short intro about the role; be sure to include elements on the team or department (50-100 words). Paragraphs should be no longer than 4 lines.',
      placeholder: 'Enter a short intro',
      options: false
    },
    responsibilities: {
      title: 'Cover the responsibilities in minimum 3 to maximum 8 bullet points. Keep it to maximum 2 lines per bullet point. (120 words max)',
      placeholder: 'Enter the key responsibilities',
      options: false
    },
    requirements: {
      title:
        'List minimum 3 maximum 8 bullet points covering experience, hard/soft skills, and behaviour Try and be as inclusive as possible: only include strict years of experience needed or degrees when it’s completely necessary. (120 words max)',
      placeholder: 'Enter the job requirements',
      options: false
    },
    points: {
      title: 'Add benefits as bullet points if needed',
      placeholder: 'Enter the selling points for the job',
      options: false
    },
    document: {
      title: 'Add an additional supporting document like a motivational letter',
      placeholder: 'Enter the type of supporting document',
      options: false
    },
    market: {
      title: 'What market is the job for?',
      placeholder: 'Select the correct market',
      options: [
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/Just-Eat.png',
          name: 'Just Eat'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/Just-Eat-Business.png',
          name: 'Just Eat Business'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/House-Icon.png',
          name: 'JET'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/House-Icon.png',
          name: 'Just Eat Takeaway'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/Menulog.png',
          name: 'Menulog'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/Skip.png',
          name: 'Skip the Dishes'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/Skip-Du-Resto.png',
          name: 'Skip the Dishes (Du Resto)'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/Just-Eat.png',
          name: 'Just Eat Switzerland'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/House-Icon.png',
          name: '10Bis (Isreal)'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/House-Icon.png',
          name: 'Pyszne.pl (Poland)'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/House-Icon.png',
          name: 'Thuisbezorgd (Netherlands)'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/House-Icon.png',
          name: 'Lieferando.at (Austria)'
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa-reverse/House-Icon.png',
          name: 'Lieferando.de (Germany)'
        }
      ]
    }
  }
};
